/*
 * @Author: yangxingxing
 * @Date: 2024-08-08 09:34:31
 * @LastEditors: yangxingxing
 * @LastEditTime: 2024-08-08 11:30:34
 * @FilePath: /daodao-biz-front/src/directives/drag.ts
 */
import type { Directive, App } from 'vue'

/**
 * 用法: v-drag 需要设置定位 absolute时拖拽会限制在父元素内 fiexd时限制在body内
 * @params x 手动修正偏移量
 * @params y 手动修正偏移量
 * @params onlyY 仅支持y轴平移
 * @params onlyX 仅支持X轴平移
 * @params draggingHandler 拖拽过程中执行的事件 会一直执行要设置好执行条件
 * @params draggEndHandler 拖拽结束执行的事件
 * 注意点：mousedown和click事件会冲突 所以拖拽时el会被设置上drag-flag属性 点击事件可以通过判断drag-flag来决定是否执行
 */
const dragDirective: Directive = {
  mounted(el, binding) {
    const oDiv = el // 当前元素

    oDiv.onmousedown = (e) => {
      let target = oDiv
      if (!['absolute', 'fixed'].includes(window.getComputedStyle(target).position)) {
        console.log('拖拽元素未设置定位属性')
        return
      }

      let isAbsolute = window.getComputedStyle(target).position === 'absolute'

      let parent = isAbsolute ? target.parentNode : document.body

      document.onselectstart = () => {
        return false
      }
      if (!target.getAttribute('init_x')) {
        target.setAttribute('init_x', target.offsetLeft)
        target.setAttribute('init_y', target.offsetTop)
      }
      const startClientX = e.clientX
      const startClientY = e.clientY
      // e.clientX, e.clientY是鼠标点击的位置
      // target.offsetLeft, target.offsetTop是当前元素左上角的位置
      // 计算鼠标按下的位置距离当前元素左上角的距离
      const disX = e.clientX - target.offsetLeft
      const disY = e.clientY - target.offsetTop
      // target.clientWidth, target.clientHeight是当前元素的尺寸
      // parent.clientWidth, parent.clientHeight是父元素的尺寸
      // parent.offsetLeft, parent.offsetTop是父元素左上角的位置
      // 可移动范围的位置
      let minX
      let maxX
      let minY
      let maxY
      let offsetX = binding.value?.x || 0
      let offsetY = binding.value?.y || 0

      if (isAbsolute) {
        minX = 0 + offsetX
        maxX = parent.clientWidth - target.clientWidth - offsetX
        minY = 0 + offsetY
        maxY = parent.clientHeight - target.clientHeight - offsetY
      } else {
        minX = parent.offsetLeft + offsetX
        maxX = parent.offsetLeft + parent.clientWidth - target.clientWidth - offsetX

        minY = parent.offsetTop + offsetY
        maxY = parent.offsetTop + parent.clientHeight - target.clientHeight - offsetY
      }

      document.onmousemove = (e) => {
        // 通过事件委托，计算移动的距离,e是最新的鼠标位置，disX、disY是鼠标刚点击时的位置
        let l = e.clientX - disX
        let t = e.clientY - disY

        binding.value.draggingHandler && binding.value.draggingHandler()
        // 约束移动范围在父元素区域内
        if (l < minX) {
          l = minX
        } else if (l > maxX) {
          l = maxX
        }
        if (t < minY) {
          t = minY
        } else if (t > maxY) {
          t = maxY
        }

        if (!binding.value?.onlyY) {
          // 给当前元素样式中的left和top赋值
          if (isAbsolute) {
            target.style.left = l + 'px'
          } else {
            // 设置成right是因为fixed放大缩小视图时基于left对位会出现错位
            target.style.left = 'unset'
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            target.style.right = screenWidth - l - target.clientWidth + 'px'
          }
        }
        if (!binding.value?.onlyX) {
          target.style.top = t + 'px'
        }
      }

      document.onmouseup = (e) => {
        document.onmousemove = null
        document.onmouseup = null
        document.onselectstart = null
        // 判断是否进行了拖拽并设置属性
        const dragFlag = startClientX != e.clientX || startClientY != e.clientY
        target.setAttribute('drag-flag', dragFlag)
        binding.value.draggEndHandler && binding.value.draggEndHandler(e)
      }

      // 不return false的话，可能导致鼠标黏连，鼠标粘在dom上拿不下来，相当于onmouseup失效
      return false
    }
  },
}

export function setupDragDirective(app: App) {
  app.directive('drag', dragDirective)
}

export default dragDirective
